// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText, Switch } from '@material-ui/core';

type Props = {
  classes: Object,
  t: Function,
  curseFilter: number,
  setCurseFilter: Function,
};

function CursingIcon(props) {
  return (
    <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.658 3.906H4.343a2.785 2.785 0 00-2.785 2.785v6.649a2.785 2.785 0 002.785 2.785h3.051l-.268 2.671a.27.27 0 00.426.246l4.056-2.917h7.05a2.785 2.785 0 002.785-2.785V6.69a2.785 2.785 0 00-2.785-2.785z"
        fill="#fff"
      />
      <path
        d="M7.395 19.273a.45.45 0 01-.448-.494l.248-2.474H4.342a2.968 2.968 0 01-2.965-2.965V6.692a2.968 2.968 0 012.965-2.965h14.315a2.968 2.968 0 012.965 2.965v6.648a2.968 2.968 0 01-2.965 2.965h-6.992l-4.009 2.883a.446.446 0 01-.261.085zM4.342 4.086a2.608 2.608 0 00-2.605 2.606v6.648a2.608 2.608 0 002.605 2.605h3.051a.18.18 0 01.18.198l-.268 2.671a.087.087 0 00.044.087.087.087 0 00.097-.005l4.057-2.917a.18.18 0 01.104-.034h7.05a2.608 2.608 0 002.606-2.605V6.692a2.608 2.608 0 00-2.606-2.606H4.342v0z"
        fill="#757575"
        stroke="#757575"
        strokeWidth={2}
      />
      <path
        d="M6.013 7.385s-.089.762-.199 1.36h.882l.205-1.388a.39.39 0 01.39-.353c.188 0 .324.112.324.369 0 .036-.103.845-.2 1.371h.316c.22 0 .39.111.39.345 0 .234-.155.345-.39.345h-.409l-.144.99h.32c.223 0 .394.11.394.346 0 .233-.153.345-.393.345h-.414l-.224 1.512c-.025.204-.142.369-.353.369a.369.369 0 01-.253-.092c-.152-.135-.1-.321-.074-.522.03-.234.114-.835.187-1.267H5.48l-.216 1.48c-.04.267-.166.4-.377.4a.373.373 0 01-.163-.043c-.238-.13-.166-.44-.142-.622.028-.217.106-.775.18-1.215h-.369c-.229 0-.38-.117-.38-.37.004-.183.122-.32.356-.32h.49l.14-.99h-.373c-.218 0-.385-.109-.385-.35 0-.2.123-.34.385-.34h.47L5.3 7.356c.028-.196.17-.341.377-.341.247 0 .365.246.335.369zm.447 3.04l.144-.99h-.886l-.14.99h.882zM9.666 10.622c0-.327.194-.56.415-.788.227-.236.693-.565.844-.941a.761.761 0 00.056-.285c0-.355-.177-.559-.509-.64-.413-.1-.969.059-1.227.059-.237 0-.417-.179-.417-.47 0-.19.115-.376.369-.453.382-.11.798-.164 1.247-.164.698 0 1.398.227 1.698.856.098.205.147.442.147.712 0 .53-.25.905-.628 1.23-.408.35-.697.47-.878.723-.204.285.068.557-.229.792a.573.573 0 01-.367.123.608.608 0 01-.184-.028c-.343-.109-.337-.378-.337-.726zm-.089 1.825c0-.315.239-.602.618-.602.33 0 .618.247.618.601 0 .333-.256.61-.618.61a.603.603 0 01-.618-.61zM13.951 9.681c-.108-.059-.205-.228-.078-.44l.365-.577-.77.02c-.184 0-.28-.132-.28-.28 0-.102.054-.207.157-.253.09-.04.131-.024.88 0l-.34-.55c-.108-.177-.077-.331.018-.42.13-.124.34-.098.435.08l.361.657.35-.626c.123-.22.303-.22.408-.156.116.07.198.239.076.433l-.36.582.77-.024a.27.27 0 01.284.278.27.27 0 01-.285.28l-.774-.02c.342.539.355.55.385.645.055.174-.011.307-.112.361-.11.06-.285.053-.397-.148l-.345-.61-.34.61c-.114.208-.287.224-.408.158zM17.64 7.36c0-.367.333-.557.673-.557.338 0 .674.187.674.558 0 .06.02-.16-.337 3.289-.028.231-.181.34-.339.34-.16 0-.316-.116-.339-.34-.354-3.461-.333-3.23-.333-3.29zm.068 4.918a.6.6 0 01.617-.602c.334 0 .618.242.618.602a.603.603 0 01-.618.606.6.6 0 01-.617-.606z"
        fill="#757575"
      />
    </svg>
  );
}

const ScribeSetCurseFilter = ({ classes, t, curseFilter, setCurseFilter }: Props) => (
  <ListItem
    style={{
      paddingLeft: 32,
    }}
  >
    <ListItemIcon>
      <CursingIcon />
    </ListItemIcon>
    <ListItemText classes={{ root: classes.listItemText }} primary={t('sidebar.curseFilter')} />

    <ListItemIcon style={{ marginRight: -7 }}>
      <Switch
        color="primary"
        onClick={() => {
          setCurseFilter(curseFilter === 2 ? 0 : 2);
        }}
        checked={curseFilter === 2}
      />
    </ListItemIcon>
  </ListItem>
);
export default withTranslation()(withStyles({})(ScribeSetCurseFilter));
